export default "__VITE_ASSET__e06b215d__"